import { render, staticRenderFns } from "./DfiSelectMultiple.vue?vue&type=template&id=a5d2fcfe&scoped=true&"
import script from "./DfiSelectMultiple.vue?vue&type=script&lang=ts&"
export * from "./DfiSelectMultiple.vue?vue&type=script&lang=ts&"
import style0 from "./DfiSelectMultiple.vue?vue&type=style&index=0&id=a5d2fcfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d2fcfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VDivider,VIcon,VMenu,VTextField})
